<template>
    <div class="card-wrapper">
        <v-card class="ma-2 elevation-3">
            <v-card-text>
                <slot name="block-elements">

                    <v-layout column>
                        <v-flex md12 class="pt-3 px-3">
                            <v-layout wrap>
                                <v-layout column>
                                    <v-flex sm6>
                                        <p class="text-sm-left">
                                            <span style="font-style: italic;">Tanácsadó:</span>&nbsp;&nbsp;
                                            <span
                                                style="font-weight: bold; color: #555;">
                                                {{ this.$store.getters.felhasznaloData.teljesnev }}&nbsp;
                                            &nbsp;{{ this.$store.getters.felhasznaloData.felhasznalo_id }}
                                        </span></p>
                                    </v-flex>
                                </v-layout>
                                <v-layout column>
                                    <v-flex sm6>
                                        <p class="text-sm-right">
                                            {{ this.$store.getters.tarifaId }} /
                                            {{ this.$store.getters.id }}
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-icon
                                                        style="margin-left: 15px;"
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        color="copyButtonColor"
                                                        :disabled="!$store.getters.id"
                                                        @click="actionTarifaMasol()"
                                                    >
                                                        {{ icons.mdiContentCopy}}
                                                    </v-icon>
                                                </template>
                                                <span>Tarifa másolása</span>
                                            </v-tooltip>
                                        </p>
                                    </v-flex>
                                </v-layout>
                            </v-layout>
                        </v-flex>
                    </v-layout>

                </slot>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import { mdiContentCopy } from '@mdi/js';

export default {

    props: {
        blockTitle: {
            type: String,
        },
    },
    methods: {
        actionTarifaMasol() {
            this.$store.commit('startLoading');
            this.$store.dispatch('tarifaMasol', {})
                .then(() => {
                    this.$router.push({ path: `/Alapadatok/${this.$store.getters.id}/${this.$store.getters.tid}` });
                    this.$store.commit('stopLoading');
                })
                .catch(() => {
                    this.$store.commit('stopLoading');
                });
        },
    },
    data() {
        return {
            icons: {
                mdiContentCopy,
            },
        };
    },
};
</script>

<style scoped>
.card-wrapper {
    margin-top: 50px;
}

.offset-header {
    top: -30px !important;
    margin: 0 auto;
    max-width: calc(100% - 32px);
}

.border-r-5 {
    /* border-radius: 5px;*/
}

.header-card {
    top: -30px !important;
    margin: 0 auto;
    max-width: calc(100% - 32px);
    min-height: 70px;
    color: white;
    /*font-weight: bold;*/
    font-size: 24px;
}

.card-header {
    transition: all ease-in-out 0.3s;
}

.headline {
    font-weight: 200 !important;
    font-size: 24px !important;
}

.hibatext-color {
    color: #8b0000;
    font-weight: bold;
}

</style>
